import React from "react";
import Table from "../../FormFields/Table";

const MessageA19 = (props) => {
  return <Table {...props} />;
};

export default MessageA19;
